"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeWindow = exports.getIsLoad = void 0;
const regist_1 = require("../../../redux/regist");
const account_1 = require("../account");
const DeletePopUpLayout_1 = require("../layout/DeletePopUpLayout");
const popup_1 = require("../popup");
const getIsLoad = (statful) => {
    const state = (0, regist_1.toState)(statful);
    return state['base/app'].isLoad;
};
exports.getIsLoad = getIsLoad;
function closeWindow(isDuplicate = false) {
    //const navigate = useNavigate();
    try {
        // localStorage와 쿠키 삭제
        localStorage.clear();
        (0, account_1.deleteCookie)('refresh_token');
        // isDuplicate가 true일 경우 사용자 확인
        if (!isDuplicate) {
            self.close();
            window.close();
        }
        else {
            const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
            const onDelete = () => {
                if (window.opener) {
                    self.close();
                    window.close();
                }
                else {
                    closePopup();
                }
                // error 페이지로 이동
                // @ts-ignore
                // location.href = '/error';
                // APP.eventManager.publish('updateMenu', 'error');
            };
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: DeletePopUpLayout_1.DeletePopUpLayout,
                componentProps: {
                    deleteContent: '중복 로그인을 지원하지 않습니다. \n사용 중인 계정을 로그아웃 합니다. 다시 접속해 주세요',
                    showCancel: false,
                    onDelete: onDelete,
                    isQnA: true,
                },
                width: 639,
                title: '중복 로그인 알림',
                isFit: true,
                isClose: false,
            });
        }
    }
    catch (e) {
        console.log('Failed to close the window:', e);
    }
}
exports.closeWindow = closeWindow;
